const hostname = "www.mec.ac.in";

export const ApiRoot =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api`
    //: "http://localhost:8000/api";
    : `https://${hostname}/api`;
